module.exports = __webpack_public_path__ + "4d52d5566f00db87240ae8451c66fa03.pdf";